import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

// 获取完整结构
export const getStructure = async () => {
  const response = await api.get('/items/structure');
  return response.data;
};

// 获取所有部分
export const getParts = async () => {
  const response = await api.get('/items/parts');
  return response.data;
};

// 根据ID获取部分
export const getPartById = async (id) => {
  const response = await api.get(`/items/parts/${id}`);
  return response.data;
};

// 获取所有条目
export const getAllItems = async () => {
  const response = await api.get('/items');
  return response.data;
};

// 根据编号获取条目
export const getItemByNumber = async (number) => {
  const response = await api.get(`/items/${number}`);
  return response.data;
};

// 随机获取一条
export const getRandomItem = async () => {
  const response = await api.get('/items/random');
  return response.data;
};

// 搜索
export const searchItems = async (query) => {
  const response = await api.get('/items/search', {
    params: { q: query },
  });
  return response.data;
};

// 根据范围获取条目
export const getItemsByRange = async (start, end) => {
  const response = await api.get(`/items/range/${start}/${end}`);
  return response.data;
};

// 文本转语音（非流式）
export const synthesizeSpeech = async (text, options = {}) => {
  const response = await api.post('/tts/synthesize', {
    text,
    voice: options.voice || 'Cherry',
    languageType: options.languageType || 'Chinese',
  }, {
    timeout: 120000, // 语音合成需要较长时间，设置120秒超时
  });
  return response.data;
};

// 文本转语音（流式）- 返回 EventSource
export const synthesizeSpeechStream = (text, options = {}) => {
  const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';
  
  // 使用 fetch API 发送 POST 请求并获取流式响应
  const abortController = new AbortController();
  

  
  const streamPromise = fetch(`${API_BASE_URL}/tts/synthesize`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      text,
      voice: options.voice || 'Cherry',
      languageType: options.languageType || 'Chinese',
    }),
    signal: abortController.signal,
    // fetch 没有内置超时选项，使用 AbortController 控制
  });
  
  return {
    streamPromise,
    abortController,
  };
};

// 获取可用语音列表
export const getVoiceList = async () => {
  const response = await api.get('/tts/voices');
  return response.data;
};

export default api;
